/* Imports */
import tippy from 'tippy.js';
import {hideAll} from 'tippy.js';

class Tooltips {
    constructor() {
        document.addEventListener('alpine:init', () => {

            // Magic: $tooltip
            Alpine.magic('tooltip', el => message => {
                if (!document.documentElement.classList.contains('mobile')) {
                    let instance = tippy(el, {
                        allowHTML: false,
                        content: message,
                        interactive: true,
                        trigger: 'manual',
                    });

                    instance.show();

                    setTimeout(() => {
                        instance.hide();

                        setTimeout(() => instance.destroy(), 150);
                    }, 2000);
                }
            });

            // Directive: x-tooltip
            Alpine.directive('tooltip', (el, { expression }) => {
                if (!document.documentElement.classList.contains('mobile')) {
                    tippy(el, {
                        allowHTML: false,
                        content: expression,
                        delay: [500, 200],
                    });
                }
            });

            // Directive: x-popover
            Alpine.directive('pop', (el, { expression }) => {
                let reference = el.getAttribute('x-pop');

                if (reference === 'story-share-popover') {
                    if (document.documentElement.classList.contains('mobile')) {
                        el.addEventListener('click', () => {
                            navigator.share({
                                title: document.title,
                                text: 'Check out this link',
                                url: location.href,
                            })
                                .then(() => {
                                    console.log('Successful share');
                                })
                                .catch((error) => {
                                    console.log('Error sharing', error);
                                });
                        });

                        return;
                    }
                }

                // This allows a template HTML to be passed into Tippy.
                // Add `data-template` with the ID of the section you wish to show within Tippy.
                // Example: <button x-data x-popover="menu">Open</button>
                tippy(el, {
                    allowHTML: true,
                    content(reference) {
                        const id = reference.getAttribute('x-pop');
                        const template = document.querySelector('[data-pop-id="'+id+'"]');

                        if (template) {
                            return template.innerHTML;
                        }
                        else {
                            console.warn('No popover template found.');
                            return null;
                        }
                    },
                    interactive: true,
                    placement: 'bottom',
                    theme: 'light-border',
                    trigger: 'click',
                    onShown: function(instance) {
                        const popoverTemplate = instance.reference ? instance.reference.getAttribute('x-pop') : null;

                        // Check for Sharethis
                        if (popoverTemplate === 'story-share-popover') {
                            if (window.__sharethis__) {
                                // Reinit Sharethis
                                window.__sharethis__.initialize();
                            }
                        }
                    }
                });
            });

            // Magic: $popHideAll
            Alpine.magic('popHideAll', el => message => {
                // Hide all tippy instances instantly
                hideAll({ duration: 0 });
            });

        });
    }
}

export default new Tooltips();
